<template>
    <div class="dashboard">
        <loading ref="opLoadScreen"/>
        <header-navigation/>
        <div class="container">
            <oops ref="opOops"/>
            <error ref="opError"/>
            <op-header ref="oHeader"/>
            <div class="opDashContent">
                <op-chart-vessels ref="oChartVessels"/>
                <op-vessels ref="oVessels"/>
                <op-platform ref="oPlatform"/>
                <op-lease ref="oLease" />
                <op-well-plans ref="oWellPlans" />
                <op-well-activity ref="oWellActivity" />
                <op-drill-permit ref="oDrillPermit" />
                <op-modify-permit ref="oModifyPermit" />
            </div>
        </div>
        <bottom-credits/>
    </div>
</template>

<script>
import axios from 'axios';
import OpHeader from '../components/operator/OpHeader.vue';
import OpPlatform from '../components/operator/OpPlatform.vue';
import OpLease from '../components/operator/OpLease.vue';
import OpWellPlans from '../components/operator/OpWellPlans.vue';
import OpWellActivity from '../components/operator/OpWellActivity.vue';
import OpDrillPermit from '../components/operator/OpDrillPermit.vue';
import OpModifyPermit from '../components/operator/OpModifyPermit.vue';
import OpVessels from '../components/operator/OpVessels.vue';
import OpChartVessels from '../components/operator/OpChartVessels.vue';
import Loading from '../components/Loading.vue';
import BottomCredits from '../components/BottomCredits.vue';
import HeaderNavigation from '../components/HeaderNavigation.vue';
import Oops from '../components/Oops.vue';
import Error from '../components/Error.vue';

export default {
    name: "Operators",
    components: {
        OpHeader,
        OpPlatform,
        OpLease,
        OpWellPlans,
        OpWellActivity,
        OpDrillPermit,
        OpModifyPermit,
        OpVessels,
        OpChartVessels,
        Loading,
        BottomCredits,
        HeaderNavigation,
        Oops,
        Error
    },
    mounted() {
        var globv = this;
        globv.$refs.opLoadScreen.startLoading();
        globv.retrieveOpData();
    },
    methods: {
        retrieveOpData: async function() {
            var globv = this;
            let operator = globv.$route.params.operator;
            // console.log(operator);
            operator = operator.toUpperCase();
            let existingOperatorInfo = null;
            if (window.sessionStorage.getItem('operator' + operator)) {
                existingOperatorInfo = JSON.parse(window.sessionStorage.getItem('operator' + operator));
            }

            if (existingOperatorInfo && Date.now() - existingOperatorInfo['created'] < 3600000) {
                globv.updateComponentInfo(existingOperatorInfo);
            }
            else {
                try {
                    let response = await axios.get('/api/operators/' + operator);
                    // console.log(response);
                    if (response && response.data) {
                        let operatorInfo = response.data;
                        try {
                            operatorInfo['created'] = Date.now();
                            window.sessionStorage.setItem('operator' + operator, JSON.stringify(operatorInfo));
                        } catch(e) { console.log(e); }
                        
                        globv.updateComponentInfo(operatorInfo);
                    }
                }
                catch (error) {
                    globv.handleError(error);
                }
            }
        },
        updateComponentInfo: function(operatorInfo) {
            let globv = this;
            globv.$refs.oHeader.updateInfo(operatorInfo['operShort']);
            let leaseInfo = operatorInfo['leases'];
            globv.$refs.oPlatform.updateInfo(operatorInfo['platforms']);
            globv.$refs.oLease.updateInfo(leaseInfo);
            globv.$refs.oWellPlans.updateInfo(operatorInfo['wellPlans']);
            globv.$refs.oWellActivity.updateInfo(operatorInfo['wellActivity']);
            globv.$refs.oDrillPermit.updateInfo(operatorInfo['drillPermits']);
            globv.$refs.oModifyPermit.updateInfo(operatorInfo['modifyPermits']);
            globv.$refs.oVessels.updateInfo(operatorInfo['vesselsVisited']);
            globv.$refs.oChartVessels.createChart(operatorInfo['timeSpentPerProvider']);
            setTimeout(globv.$refs.opLoadScreen.finishLoading, 500);
        },
        handleError: function(error) {
            var globv = this;
            // console.log(error, error.response);
            try {
                error = error.response.data;
                if (error['error'] && error['error']['status'] < 500) {
                    if (error['error']['status'] == 404)
                        globv.$refs.opError.showError({
                            status: 404, 
                            title: "Not Found", 
                            message: error['error']['message']
                        });
                    else
                        globv.$refs.opError.showError({
                            status: error['error']['status'],
                            message: error['error']['message']
                        });
                }
            }
            finally {
                globv.$refs.opOops.showOops();
            }
                

            setTimeout(globv.$refs.opLoadScreen.finishLoading, 500);
        }
    }
}
</script>

<style lang="scss">
.opDashContent {
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    align-self: center;
    flex: 1 0 auto;

    & > .card {
        width: 80%;
        max-width: 1200px;
    }
}

@media (max-width: 1200px) {
    .opDashContent {
        .card {
            width: 100%;
            margin: 20px 10px;
        }
    }
}

@media (max-width: 935px) {
    .opDashContent {
        padding: 0;
        
        .card {
            margin: 20px 0;
        }
    }
}

@media (max-width: 420px) {
    .opDashContent .cardContent {
        padding: 0 10px 10px;
    }
}
</style>